<template>
  <basic-modal
    title="Changelog"
    :width="750"
    :is-showing="show"
    :on-cancel="close"
    :on-submit="close"
    submit-text="Ok, gelezen"
    submit-icon="mdi-heart"
  >
    <div
      class="changelog"
      v-html="changelogText"
    />
  </basic-modal>
</template>

<script>
import BasicModal from '@bit/streamline.web.basic-modal'

export default {
  components: {
    BasicModal
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      changelogText: ''
    }
  },
  created () {
    fetch('/assets/html/changelog.html')
      .then(res => res.text())
      .then(text => text.replace(/\((\d\d\d\d)-(\d\d)-(\d\d)\)/g, (match, year, month, day) => `(${new Date(year, month - 1, day).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })})`)) // Create a human readable date
      .then(text => text.replace(/\(<a href=".+?">[\d\w]{7}<\/a>\)/g, '')) // Remove the link to the GitLab commit page
      .then(text => text.replace(/<h3>.*(\d+\.\d+\.\d+).*(\(.+ \d\d\d\d\))<\/h3>/g, '<hr><h2><strong>v$1 $2</strong></h2>')) // Add an horizontal rule before each new release and make the release heading h2
      .then(text => { this.changelogText = text })
  },
  methods: {
    close () {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss">
  .basic-modal {
    .changelog {
      hr:first-of-type {
        display: none;
      }
      h2 {
        line-height: 2em;
        font-size: 1.1em;
      }
      h3 {
        line-height: 1.5em;
        font-weight: bold;
      }
      ul {
        margin-bottom: 1.2em;

        li {
          list-style-type: disc;
          margin-bottom: 0.3em;
        }
      }
      strong {
        color: rgb(11, 95, 159);
      }
    }
  }
</style>
